import { requireValue } from '../require_value.js';
import {
  AirplaneTakeoffIcon,
  BedIcon,
  BusIcon,
  CarIcon,
  CarProfileIcon,
} from '@phosphor-icons/react';
import { useGenUiI18n } from '../ui/i18n.js';
import { TRIP_STATUS_UI, tripStatusLabel } from './trip_maps.js';
import './trip.css';

/** Ícone do modal a partir do nome Phosphor (subset dos modais suportados). */
export function ModalIcon({ icon, size }: { readonly icon: string; readonly size: number }) {
  switch (icon) {
    case 'airplane-takeoff':
      return <AirplaneTakeoffIcon size={size} aria-hidden />;
    case 'bed':
      return <BedIcon size={size} aria-hidden />;
    case 'bus':
      return <BusIcon size={size} aria-hidden />;
    case 'car':
      return <CarIcon size={size} aria-hidden />;
    case 'car-profile':
      return <CarProfileIcon size={size} aria-hidden />;
    default:
      return null;
  }
}

/** Badge de status da viagem (pill tonal). Default `UPCOMING` para status nulos. */
export function TripStatusBadge({ status }: { readonly status: string | null }) {
  const { t } = useGenUiI18n();
  const meta =
    (status != null && TRIP_STATUS_UI[status]) || requireValue(TRIP_STATUS_UI['UPCOMING']);
  return <span className={`tbadge tbadge--${meta.variant}`}>{tripStatusLabel(status, t)}</span>;
}

/** Uma linha chave/valor; `v` nulo/vazio vira estado vazio rotulado (`is-empty`). */
export type KvRow = { k: string; v: string | null; empty?: string };

/** Grade de pares chave/valor (`.tkv`) usada no resumo da viagem e no detalhe
 *  por modal. Valor nulo/vazio renderiza `empty` (default "Não informado"),
 *  nunca string vazia ou "null". */
export function KvGrid({ rows }: { readonly rows: KvRow[] }) {
  const { t } = useGenUiI18n();
  return (
    <div className="tkv">
      {rows.map((r, i) => (
        <div className="tkv__cell" key={`${r.k}-${String(i)}`}>
          <span className="tkv__k">{r.k}</span>
          {r.v != null && r.v !== '' ? (
            <span className="tkv__v">{r.v}</span>
          ) : (
            <span className="tkv__v is-empty">{r.empty ?? t('common.notInformed')}</span>
          )}
        </div>
      ))}
    </div>
  );
}
